import R from 'ramda';
import { Observable, Subject } from 'rxjs';

export const fetch = url =>
  Observable.ajax({
    url: url,
    crossDomain: true,
  }).map(R.path(['response']));

export const ajaxWithProgress = options => {
  const progress$ = new Subject();
  const ajax$ = Observable.ajax({
    ...options,
    progressSubscriber: progress$,
    crossDomain: true,
  });

  return Observable.merge(ajax$, progress$);
};



// WEBPACK FOOTER //
// ./src/common/ajax.js